// « Nouvel éditeur mobile » — the bottom tab bar (icon + short French label).
// Each tab opens a bottom sheet hosting the editor's EXISTING components.
import { M2 } from './theme';
import { M2_TABS, type M2Tab } from './m2Model';

export function MobileTabBar({ active, onSelect, compact = false }: { active: M2Tab | null; onSelect: (tab: M2Tab) => void; compact?: boolean }) {
  return (
    <nav
      data-m2-tabbar=""
      aria-label="Outils de l'album"
      className="m2-tabbar shrink-0 grid grid-cols-5"
      style={{
        background: M2.surface,
        borderTop: `1px solid ${M2.gold}26`,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      {M2_TABS.map(({ key, label, icon }) => {
        const on = active === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onSelect(key)}
            aria-pressed={on}
            aria-label={label}
            // sideways (compact): icon and label on one 44 px line
            className={compact
              ? 'min-h-11 flex flex-row items-center justify-center gap-1.5 px-0.5 active:scale-95 transition-transform'
              : 'min-h-[54px] flex flex-col items-center justify-center gap-0.5 px-0.5 active:scale-95 transition-transform'}
            style={{ color: on ? M2.goldInk : M2.muted, fontWeight: on ? 700 : 500 }}
          >
            <svg width={compact ? 20 : 22} height={compact ? 20 : 22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={on ? 2.1 : 1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              {icon}
            </svg>
            <span className="leading-tight text-center" style={{ fontSize: 11 }}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
